import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

const rootElement = document.getElementById("root");

if (process.env.NODE_ENV === "production") {
  console.log = function () {};
  console.warn = function () {};
  console.error = function () {};
}

if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(<App />);
} else {
  console.error("Root element not found");
}
